import React,{useState,useEffect} from 'react'
import {Collapse} from '@material-ui/core'
import Select from 'react-select'
import Chevron from 'assets/icon/chevron.png'
import { CircularProgress } from '@material-ui/core'
import { useDispatch,useSelector } from 'react-redux'
import { getBeranda } from 'redux/actions/forum'
import { setPersist } from 'redux/actions/persist'
import { forumAuth } from 'redux/actions/auth'
import Cookie from 'universal-cookie'

const cookie=new Cookie()
const token=cookie.get('login_cookie_forum')

export default function Filter() {
    const dispatch = useDispatch()
    const general = useSelector(state => state.general)
    const reducer = useSelector(state => state.reducer)
    const persist = useSelector(state => state.persist)
    const {forum_filter}=reducer
    const {forum_sort,filter_action,forum_id,channel_id}=persist
    const [tab, settab] = useState({
        filter:true,
        kursus:false
    })
    
    const [kategory, setkategory] = useState({})
    const [channel, setchannel] = useState('home')
    const [channelqu, setchannelqu] = useState('')
    const [perpage, setperpage] = useState(20)
    useEffect(() => {
        if(filter_action==='kursusqu'){
            setchannelqu(parseInt(forum_id))
            setchannel('')
            settab({filter:false,kursus:true})
        }
        if(filter_action==='channels'){
            setchannel(parseInt(forum_id))
            setkategory({...kategory,[channel_id]:true})
        }
        if(filter_action==='home'){
            setchannel('home')
            let {home}=forum_filter
            if(home.length>0){
                dispatch(getBeranda(`/${home[0].forumId}/${forum_sort}/${1}/${perpage}`))
                dispatch(forumAuth(home[0].forumId,token))
                dispatch(setPersist({forum_id:home[0].forumId}))
            }
            setchannelqu('')
            dispatch(setPersist({filter_action:'home'}))

        }
    }, [])
    const choiceChannel=(key,data)=>{
        setchannel(data.forumId)
        if(data.forumId){
            dispatch(getBeranda(`/${data.forumId}/${forum_sort}/${1}/${perpage}`))
            dispatch(forumAuth(data.forumId,token))
            dispatch(setPersist({forum_id:data.forumId}))
        }
        setchannelqu('')
        dispatch(setPersist({filter_action:'channels'}))
    }
    const choiceHome=()=>{

        setchannel('home')
        let {home}=forum_filter
        if(home.length>0){
            dispatch(getBeranda(`/${home[0].forumId}/${forum_sort}/${1}/${perpage}`))
            dispatch(forumAuth(home[0].forumId,token))
            dispatch(setPersist({forum_id:home[0].forumId}))
        }
        setchannelqu('')

        dispatch(setPersist({filter_action:'home'}))

    }
    const choiceChannelQu=(forum)=>{
        setchannelqu(forum.forumId)
        setchannel('')
        setkategory({})
        dispatch(getBeranda(`/${forum.forumId}/${forum_sort}/${1}/${perpage}`))
        dispatch(forumAuth(forum.forumId,token))
        
        dispatch(setPersist({forum_id:forum.forumId}))
        dispatch(setPersist({filter_action:'kursusqu'}))
    }
    const kursusQuCollapse=()=>{
        settab({kursus:!tab.kursus})
    }
    const onSetKategory=(data)=>{
        setkategory({...kategory,[data.channelId]:!kategory[data.channelId]})
        settab({kursus:false})

    }
    return (
        <div >
            <div className='home-filter'>
                <div className='filter-content'>
                    <div className='kategory-wrapper '>
                        {general.isLoadingTable?
                            <div style={{textAlign:'center'}}>
                                <CircularProgress style={{color:'#ff4e4e'}}  size={35} />
                            </div>
                        :
                            <div>

                                <div onClick={()=>choiceHome()} className={`kategory-item ${channel==='home'&&'active-kat'} `}>
                                    <p className='font-nunito margin-0'>Home</p>
                                </div>
                                {forum_filter.channels.map((data,i)=>(
                                    <div key={i}>
                                        <div onClick={()=>choiceChannel(data.shortname,data)} className={`kategory-item ${channel!=='home'&&channel!==''&&'active-kat'} `}>
                                            <p className='font-nunito margin-0'>{data.shortname}</p>
                                        </div>
                                        {channel!=='home'&&channel!==''&&
                                        <div className='cdhx-kat'>
                                            <div onClick={()=>onSetKategory(data)} className='div-flex div-justify-between div-align-center cursor-pointer'>
                                                <p className='font-nunito font-bold margin-0'>Kategori ({data.forums.length})</p>
                                                <img  src={Chevron} className={kategory[data.channelId]?'chevron-open':'chevron-close'} alt="chevron"/>
                                            </div>
                                            <Collapse in={kategory[data.channelId]}>
                                                <div className='kategory-wrapper'>
                                                    {data.forums.map((forum,i2)=>(
                                                        <div key={i2} onClick={()=>choiceChannel(forum.name,forum)} className={`kategory-item ${channel===forum.forumId&&'active-kat'} `}>
                                                            <p className='font-nunito margin-0'>{forum.name}</p>
                                                        </div>
                                                    ))}
                                                    
                                                    <div style={{textAlign:'right',marginTop:20}}>
                                                        <a href="/topic"><p className='font-nunito font-bold margin-0 cursor-pointer' style={{color:'#ff4e4e',fontSize:12}}>Tambah favorit kategori</p></a>
                                                    </div>
                                                </div>
                                            </Collapse>
                                        </div>}
                                    </div>
                                ))}
                               
                               
                                
                            </div>
                        }
                        
                        
                    </div>
                </div>
               
            </div>
            <br/>
            {forum_filter.kursusQu.length>0&&<div className='home-filter'>
            {general.isLoadingTable?
                <div style={{textAlign:'center'}}>
                    <CircularProgress style={{color:'#ff4e4e'}}  size={35} />
                </div>
            :
            
            <div>
                <div onClick={()=>kursusQuCollapse()} className='cursor-pointer div-flex div-justify-between div-align-center'>
                    <p className='font-nunito font-bold margin-0'>KursusQu</p>
                    <img  src={Chevron} className={tab.kursus?'chevron-open':'chevron-close'} alt="chevron"/>
                </div>
                <Collapse in={tab.kursus}>
                    <div className='filter-content'>
                        <div className='kategory-wrapper'>
                            {forum_filter.kursusQu.map((forum,i)=>(
                                <div key={i} onClick={()=>choiceChannelQu(forum)} className={`kategory-item ${channelqu===forum.forumId&&'active-kat'} `}>
                                    <p className='font-nunito margin-0'>{forum.name}</p>
                                </div>
                            ))}
                           
                        </div>
                    </div>

                </Collapse>
                </div>
            }
            </div>}
            <br/>
        </div>
    )
}
